import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=2a2038ae&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=2a2038ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2038ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a2038ae', component.options)
    } else {
      api.reload('2a2038ae', component.options)
    }
    module.hot.accept("./PlanCard.vue?vue&type=template&id=2a2038ae&scoped=true&", function () {
      api.rerender('2a2038ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PlanCard.vue"
export default component.exports